import {useEffect, useState} from "react";
import TestResolutionPage from "./test-resolution-page";
import {TestInstructionsComponent} from "./test-instructions.component";
import {useQuizAssessmentTestDataProvider} from "../../providers/data-provider/quiz-assessment-test.data.provider";
import {
    useQuizAssessmentAvailabilityDataProvider
} from "../../providers/data-provider/quiz-assessment-availability.data.provider";
import {useNotify} from "react-admin";

export const TestSolve = (props) => {
    const [test, setTest] = useState();
    const [availability, setAvailability] = useState();
    const { startTest, loading } = useQuizAssessmentTestDataProvider()
    const { findAvailability } = useQuizAssessmentAvailabilityDataProvider();
    const availabilityId = props.match.params.availabilityId
    const notify = useNotify();

    useEffect(() => {
        if (availabilityId) {
            findAvailability(availabilityId).then(res => setAvailability(res.data))
        }
    }, [findAvailability, availabilityId]);

    const handleStartTest = async () => {
        startTest(availabilityId).then(res => setTest(res.data))
            .catch(err => {
                notify('Não foi possível iniciar a avaliação. Tente novamente mais tarde ou contacte o professor responsável ', 'error' )
            });
    };

    if (test) {
        return <TestResolutionPage availability={availability} data={test}  />;
    }
    return (
        <TestInstructionsComponent handleStartTest={handleStartTest} loading={loading} />
    );


}